import React from 'react';

// Host only. Lists guests waiting to be let in, with Admit and Deny for each, and Admit all.
export default function WaitingRoomPanel({ waiting, onAdmit, onDeny, onAdmitAll }) {
  if (!waiting || waiting.length === 0) return null;
  return (
    <div
      role="region"
      aria-label="Waiting room"
      style={{
        position: 'fixed', top: 80, right: 16, zIndex: 1200, width: 280,
        background: '#1e1e1e', color: '#eee', border: '1px solid #333',
        borderRadius: 8, padding: 12, boxShadow: '0 6px 18px rgba(0,0,0,0.4)',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <strong>Waiting room ({waiting.length})</strong>
        {waiting.length > 1 && (
          <button type="button" onClick={onAdmitAll} style={{ background: '#1557c8', color: '#fff', border: 'none', borderRadius: 4, padding: '4px 8px', cursor: 'pointer' }}>
            Admit all
          </button>
        )}
      </div>
      {waiting.map((guest) => (
        <div key={guest.socketId} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, padding: '6px 0', borderTop: '1px solid #2a2a2a' }}>
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{guest.name}</span>
          <span style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
            <button type="button" onClick={() => onAdmit(guest.socketId)} style={{ background: '#2e7d32', color: '#fff', border: 'none', borderRadius: 4, padding: '4px 8px', cursor: 'pointer' }}>
              Admit
            </button>
            <button type="button" onClick={() => onDeny(guest.socketId)} style={{ background: '#3a3a3a', color: '#eee', border: '1px solid #555', borderRadius: 4, padding: '4px 8px', cursor: 'pointer' }}>
              Deny
            </button>
          </span>
        </div>
      ))}
    </div>
  );
}
